export default __webpack_public_path__ + "static/media/send-icon.f842e026.svg";